import moment from 'moment';

import { useGilt, useTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import asObject from 'utils/objects/asObject.util';

const STYLE_PURPLE_CELL = Object.freeze({
  whiteSpace: 'nowrap',
  backgroundColor: '#933cc1',
  textAlign: 'center',
  verticalAlign: 'top',
  fontFamily: 'Open Sans,sans-serif',
  height: '36px',
  paddingTop: '0',
  paddingBottom: '0',
  paddingRight: '0',
  paddingLeft: '0',
  borderBottom: '1px solid #e5e5e5',
  color: '#fff',
});

const STYLE_BOLD_LEFT = Object.freeze({
  marginLeft: ' 42px',
  textAlign: 'left',
  fontSize: '14px',
  lineHeight: '20px',
  fontFamily: 'Open Sans,sans-serif',
  width: '122px',
});

const STYLE_TITLE = Object.freeze({
  textAlign: 'right',
  fontSize: '13px',
  lineHeight: '17px',
  fontFamily: 'Open Sans,sans-serif',
  color: '#fff',
  marginRight: '48px',
  marginTop: '5px',
});

const STYLE_DATE = Object.freeze({
  textAlign: 'right',
  fontSize: '13px',
  fontFamily: 'Open Sans,sans-serif',
  color: '#fff',
  marginRight: '48px',
  marginBottom: '0',
});

const STYLE_TABLE = Object.freeze({
  borderCollapse: 'collapse',
  width: '100%',
  maxWidth: '800px',
  margin: '0 auto',
  fontFamily: 'Open Sans,sans-serif',
});

const compareStartTimes = (a, b) => moment(a.start_time) - moment(b.start_time);

const EmailClientNextAppointment = ({ client }) => {
  const { t } = useTranslation();
  const { formatDate } = useGilt();

  const clientObject = asObject(client);
  const nextAppointment = asObject(clientObject.nextAppointment);
  const firstProcedure = asArray(nextAppointment.procedures).sort(compareStartTimes)[0];

  const appointmentTitle = nextAppointment ? fromAnyToString(nextAppointment.title).split(',').join(', ') : '';

  const startTime = formatDate(firstProcedure?.start_time);

  const shouldRender = fromAnyToBool(firstProcedure);

  if (!shouldRender) {
    return null;
  }

  return (
    <table data-bem="EmailClientNextAppointment" style={STYLE_TABLE}>
      <tbody>
        <tr>
          <td height="40" style={STYLE_PURPLE_CELL}>
            <h2 style={STYLE_BOLD_LEFT}>
              {t('composite.email.clientNextAppointment.nextAppointment')} <br />
              {t('composite.email.clientNextAppointment.details')}
            </h2>
          </td>
          <td style={STYLE_PURPLE_CELL}>
            <p style={STYLE_DATE}>{startTime}</p>
            <p style={STYLE_TITLE}>{appointmentTitle}</p>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default EmailClientNextAppointment;
